import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { UserSettlementModel } from "../../model/usersettlement.model";
import { DriverSettlementFormComponent } from "../driversettlement-form/driversettlement-form.component";
import { GridFilter, LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { DriverSettlementMenuComponent } from "../driverSettlementSetting";
import { DriverSettlementFormSettingModel } from "../driversettlementformsetting.model";
import { Permission } from "projects/sepidz-web-framework/src/lib/models";

@Component({
  selector: "ngx-driversettlement-list.component",
  templateUrl: "./driversettlement-list.component.html",
  styleUrls: ["./driversettlement-list.component.scss"],
})
export class DriverSettlementListComponent extends BaseListComponent {
  menu = DriverSettlementMenuComponent;
  driverSettlementformsetting: DriverSettlementFormSettingModel;
  settlementList: UserSettlementModel[];
  unSortableFilterable: string[] = [];
  formVisible: boolean = true;
  protected storage: LocalStoreManager;
  filters: GridFilter[] = [
    {
      Filed: "Code",
      Value: 0,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    },
  ];
  constructor() {
    super();
    this.inputEditorform = DriverSettlementFormComponent;
    if (!this.accountService.userHasPermission(`General:DriverSettlementFormSetting`, Permission.viewPermission)) {
      this.sts.showToast("danger", "", this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.DoNotHaveAccessSection"));
      this.formVisible = false;
    }
  }
  ngOnInit() {
    this.apiName = "DriverSettlement";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.ReceiveByCourier");
    if (
      (this.accountService.authService.currentInformation().BranchingAdvancedEnabled ||
        this.accountService.authService.currentInformation().BranchingLightEnabled ||
        this.accountService.authService.currentInformation().RestaurantCallCenter) &&
      !this.accountService.authService.currentBranch?.AccessToAllBranches
    ) {
      this.filters.push({
        Filed: "BranchId",
        Value: this.accountService.authService.currentBranchId,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      });
    }
    const columnsToExclude = ["TotalReceipt", "TotalPay", "NewRemainValue"];

    this.unSortableFilterable.push(...columnsToExclude);
  }
}
